// extracted by mini-css-extract-plugin
export default {"drawerWrapper":"LeftDrawer_drawerWrapper__7hfGw"};